import { HttpErrorResponse } from '@angular/common/http';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as WatchlistActions from './watchlist.actions';
import { WatchlistItem, WatchlistItemIdentity } from './watchlist.models';

export const WATCHLIST_FEATURE_KEY = 'watchlist';

export interface WatchlistState extends EntityState<WatchlistItem> {
  loaded: boolean; // has the Watchlist list been loaded
  error?: HttpErrorResponse | null; // last known error (if any)
}

export interface WatchlistPartialState {
  readonly [WATCHLIST_FEATURE_KEY]: WatchlistState;
}

export function selectWatchlistItemId(watchlistItem: WatchlistItemIdentity) {
  return `${watchlistItem.fair_id}/${watchlistItem.entity_type}/${watchlistItem.entity_id}`;
}

export const watchlistAdapter: EntityAdapter<WatchlistItem> = createEntityAdapter<WatchlistItem>({
  selectId: selectWatchlistItemId,
});

export const initialWatchlistState: WatchlistState = watchlistAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

const reducer = createReducer(
  initialWatchlistState,
  on(WatchlistActions.loadWatchlistSuccess, (state, { items }) =>
    watchlistAdapter.setAll(items, { ...state, loaded: true })
  ),
  on(WatchlistActions.addWatchlistItemSuccess, (state, watchlistItem) =>
    watchlistAdapter.addOne(watchlistItem.watchlistItem, state)
  ),
  on(WatchlistActions.removeWatchlistItemSuccess, (state, watchlistItem) =>
    watchlistAdapter.removeOne(selectWatchlistItemId(watchlistItem.watchlistItem), state)
  ),
  on(WatchlistActions.loadWatchlistFailure, (state, { error }) => ({ ...state, error }))
);

export function watchlistReducer(state: WatchlistState | undefined, action: Action) {
  return reducer(state, action);
}
